<script setup>
import { EyeIcon } from "@heroicons/vue/24/solid";
import ActionButton from "@js/components/ActionButton.vue";
import { useI18n } from "vue-i18n";

const { icon, link } = defineProps({
  icon: {
    type: [Object, Function],
    required: true,
  },
  link: {
    type: String,
    required: true,
  },
});

const { t } = useI18n();
</script>

<template>
  <li
    class="flex flex-col items-start justify-between gap-4 px-4 py-3 leading-6 md:flex-row md:items-center"
  >
    <div class="flex items-center gap-2">
      <component :is="icon" class="size-5 flex-shrink-0" />

      <span class="truncate font-medium">
        <slot />
      </span>
    </div>

    <ActionButton :href="link" :icon="EyeIcon" target="_blank" size="small" />
  </li>
</template>
